import React, { useContext } from "react";

export const MobileAppModalContext = React.createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([undefined, undefined]);

export function useMobileAppModalContextData() {
  return useContext(MobileAppModalContext);
}
